import classnames from 'classnames'
import { FormikProvider, useFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CommentRootUuid } from '../../../models/Comment'
import useCreateComment from '../../../state/mutations/useCreateComment'
import FormButtons from '../../basics/FormButtons/FormButtons'
import { TextAreaFormik } from '../../basics/TextArea/TextArea'
import { TextInputFormik } from '../../basics/TextInput/TextInput'

import styles from './CreateThreadForm.module.scss'
import set from 'lodash/set'

type CreateThreadFormProps = {
  onClose: () => void
} & CommentRootUuid

export default React.memo(function CreateThreadForm({ onClose, ...rootUuid }: CreateThreadFormProps) {
  const { t } = useTranslation()

  const createComment = useCreateComment()
  const formik = useFormik({
    initialValues: {
      ...rootUuid,
      title: '',
      text: '',
    },
    validate: (values) => {
      const errors = {}

      if (values.text && values.text.length > 2048) {
        set(errors, `text`, t('errors.fields.message.not longer then', { number: 2048 }))
      }

      if (values.title && values.title.length > 255) {
        set(errors, `title`, t('errors.fields.message.not longer then', { number: 255 }))
      }

      return errors
    },
    onSubmit: async (values, { setStatus }) => {
      setStatus()
      try {
        await createComment.mutateAsync({ ...values })

        onClose()
      } catch (err) {
        setStatus(String(err))
      }
    },
  })

  return (
    <FormikProvider value={formik}>
      <form noValidate onSubmit={formik.handleSubmit} className={classnames(styles.CreateThreadForm)}>
        <header>
          <hgroup>
            <h1>{t('comment.title create thread')}</h1>
          </hgroup>
        </header>

        <div>
          <TextInputFormik name="title" label={t('comment.field title')} required />
          <TextAreaFormik name="text" label={t('comment.field text')} required />
        </div>

        <FormButtons onClose={onClose} {...formik} />
      </form>
    </FormikProvider>
  )
})
